/**
 * Fill these in before deploying. Left as anchors/placeholders so the page
 * builds and ships cleanly without a live listing.
 */
export const LINKS = {
  chromeWebStore: '#install',
  github: '#',
  securityPolicy: '#',
  midnightNetwork: 'https://midnight.network',
};
